"use strict";

const options_collection = {

  collectionsLoadMore: ".collections-load-more",

  rangeSlider: ".price-range .range-slider",

  rangeSliderMin: ".range-slider-min",

  rangeSliderMax: ".range-slider-max",

  minPriceRange: ".min-price-range",

  maxPriceRange: ".max-price-range",

  collectionSidebar: "#CollectionSidebar",

  collectionFilterBlocks: ".filter-blocks",

  productgridcontainer: "#productgridcontainer",

  collectionFiltersForm: "#CollectionFiltersForm",

  section: ".sec__collection-main",

};



class BtnFilter extends HTMLElement {

  constructor() {

    super();

    this.collectionSidebar = document.getElementById("CollectionSidebar");

    this.addEventListener("click", this.onOpen.bind(this), false);

  }

  onOpen() {

    if (!this.classList.contains("open")) {

      this.collectionSidebar.classList.add("open");

      document.documentElement.classList.add("open-drawer", "open-sidebar");

      if (getScrollBarWidth.init()) root.style.setProperty("padding-right", getScrollBarWidth.init() + "px");

      this.classList.add("open");

    } else {

      this.collectionSidebar.classList.remove("open");

      document.documentElement.classList.remove("open-drawer", "open-sidebar");

      root.style.removeProperty("padding-right");

      this.classList.remove("open");

    }

  }

}

customElements.define("btn-filter", BtnFilter);



class CloseFilter extends HTMLElement {

  constructor() {

    super();

    this.collectionSidebar = document.getElementById("CollectionSidebar");

    this.addEventListener("click", this.onClose.bind(this), false);

  }

  onClose() {

    this.collectionSidebar.classList.remove("open");

    document.documentElement.classList.remove("open-drawer", "open-sidebar");

    document.querySelector(".btn-filter").classList.remove("open");

    root.style.removeProperty("padding-right");

  }

}

customElements.define("close-filter", CloseFilter);



class FacetApplyCanvas extends CloseFilter {

  constructor() {

    super();

    this.addEventListener("click", this.onClose.bind(this), false);

  }

}

customElements.define("facet-apply-canvas", FacetApplyCanvas);



class GridMode extends HTMLElement {

  constructor() {

    super();

    this.addEventListener("click", this.gridMode.bind(this), false);

  }

  gridMode() {

    const view_mode = this.getAttribute("data-grid-mode");

    if (this.classList.contains("active")) return;

    if (view_mode == 1) return;

    for (var item of document.querySelectorAll("grid-mode")) {

      item.classList.remove("active");

    }

    const container_switch = document.querySelector(

      ".container-products-switch"

    );

    this.classList.add("active");

    const data_view_mode = container_switch.getAttribute("data-view-mode");

    container_switch.classList.remove("grid-columns-" + data_view_mode);

    container_switch.setAttribute("data-view-mode", view_mode);

    container_switch.classList.add("grid-columns-" + view_mode);

  }

}

customElements.define("grid-mode", GridMode);



class ViewMode extends HTMLElement {

  constructor() {

    super();

    this.addEventListener("click", this.viewMode.bind(this), false);

  }

  viewMode() {

    const view_mode = this.getAttribute("data-view");

    if (this.classList.contains("actived")) return;

    var queryString = window.location.search;

    queryString = eventCollectionShopify.removeParam("view", queryString);

    if (view_mode == "list") {

      var searchParams = queryString.replace("?", "") + "&view=list";

    } else {

      var searchParams = queryString.replace("?", "") + "&view=grid";

    }

    const url = eventCollectionShopify.renderUrl(searchParams);

    eventCollectionShopify.renderSectionFilter(url, searchParams);

  }

}

customElements.define("view-mode", ViewMode);



class FilterItem extends HTMLElement {

  constructor() {

    super();

    this.addEventListener("click", this.filterItem.bind(this), false);

  }

  filterItem() {

    if (this.querySelector(".tooltip")) {

      this.querySelector(".tooltip").classList.toggle("current-filter");

    } else {

      if (this.closest("li")) {

        this.closest("li").classList.toggle("current-filter");

      }

    }

    const url = this.getAttribute("data-href");

    eventCollectionShopify.renderSectionFilter(url);

  }

}

customElements.define("filter-item", FilterItem);



class FacetClearAll extends CloseFilter {

  constructor() {

    super();

    this.addEventListener("click", this.filterItem.bind(this), false);

  }

  filterItem() {

    const url = this.getAttribute("data-href");

    eventCollectionShopify.renderSectionFilter(url);

    this.onClose();

  }

}

customElements.define("facet-clear-all", FacetClearAll);



class FilterSort extends HTMLElement {

  constructor() {

    super();

    this.addEventListener("click", this.filterSort.bind(this), false);

  }

  filterSort() {

    const value = this.getAttribute("value");

    let queryString = window.location.search;

    queryString = eventCollectionShopify.removeParam("sort_by", queryString);

    const searchParams = queryString.replace("?", "") + "&sort_by=" + value;

    const url = eventCollectionShopify.renderUrl(searchParams);

    eventCollectionShopify.renderSectionFilter(url, searchParams);

  }

}

customElements.define("filter-sort", FilterSort);



class SelectSorter extends HTMLElement {

  constructor() {

    super();

    this.addEventListener("click", this.activeFilterSort.bind(this), false);

  }

  activeFilterSort() {

    if (this.closest(".select-custom").classList.contains("active")) {

      this.closest(".select-custom").classList.remove("active");

    } else {

      this.closest(".select-custom").classList.add("active");

    }

  }

}

customElements.define("select-sorter", SelectSorter);



var eventCollectionShopify = (function () {

  return {

    init: function () {

      this.ionRangeSlider();

      let windowWidth = window.innerWidth;

      if (windowWidth <= 1024) {

        const horizontal = document.querySelector(".horizontal-filter");

        if (horizontal) {

          const collapsible = document.querySelectorAll("collapsible-block");

          collapsible.forEach((e) => {

            e.classList.add("active");

          });

        }

      }

    },



    ionRangeSlider: function () {

      const price_range = document.querySelector(".price-range");

      const maxRange = document.querySelector(

        options_collection.rangeSliderMax

      );

      const minRange = document.querySelector(

        options_collection.rangeSliderMin

      );

      const minPrice = document.querySelector(".min-price-range");

      const maxPrice = document.querySelector(".max-price-range");

      var minPriceRange = 0;

      var maxPriceRange = 0;

      if (!price_range) return;

      document

        .querySelector(options_collection.minPriceRange)

        .addEventListener(

          "change",

          (event) => {

            event.preventDefault();

            const target = event.currentTarget;

            target.value = target.value.replace(',','')

            if (Number(minRange.min) + Number(target.value) >= 0) {

              if (Number(target.value) > Number(maxRange.max)) {

                minPrice.value = Number(maxRange.max);

              } else {

                minPrice.value = Number(target.value);

              }

            } else {

              minPrice.value = Number(minRange.min);

            }

            const formData = new FormData(

              document.querySelector(options_collection.collectionFiltersForm)

            );

            const params = new URLSearchParams(formData).toString();

            const nameMin = minPrice.getAttribute("name");

            const nameMax = maxPrice.getAttribute("name");

            var queryString = window.location.search;

            queryString = this.removeParam(nameMin, queryString);

            queryString = this.removeParam(nameMax, queryString);

            var searchParams = queryString.replace("?", "") + "&" + params;

            const url = this.renderUrl(searchParams);

            this.renderSectionFilter(url, searchParams);

          },

          false

        );

      document

        .querySelector(options_collection.maxPriceRange)

        .addEventListener(

          "change",

          (event) => {

            event.preventDefault();

            const target = event.currentTarget;

            target.value = target.value.replace(',','')

            if (Number(maxRange.max) - Number(target.value) >= 0) {

              maxPrice.value = Number(target.value);

            } else {

              maxPrice.value = Number(maxRange.max);

            }

            const formData = new FormData(

              document.querySelector(options_collection.collectionFiltersForm)

            );

            const params = new URLSearchParams(formData).toString();

            const nameMin = minPrice.getAttribute("name");

            const nameMax = maxPrice.getAttribute("name");

            var queryString = window.location.search;

            queryString = this.removeParam(nameMin, queryString);

            queryString = this.removeParam(nameMax, queryString);

            var searchParams = queryString.replace("?", "") + "&" + params;

            const url = this.renderUrl(searchParams);

            this.renderSectionFilter(url, searchParams);

          },

          false

        );

      document

        .querySelector(options_collection.rangeSliderMin)

        .addEventListener(

          "input",

          (event) => {

            event.preventDefault();

            const target = event.currentTarget;

            if (Number(maxRange.value) - Number(target.value) >= 1) {

              minPrice.value = Number(target.value);

              minPriceRange = Number(target.value) * 100;

            } else {

              target.value = Number(maxRange.value) - 1;

              minPriceRange = (Number(maxRange.value) - 1) * 100;

            }

            const price_format = Shopify.formatMoney(

              minPriceRange,

              cartStrings.money_format

            );

            document.querySelector(".price-lable .min").innerHTML =

              price_format;

            target

              .closest(".price-range")

              .style.setProperty(

                "--range-from",

                (minRange.value / Number(target.getAttribute("max"))) * 100 +

                  "%"

              );

          },

          false

        );

      document

        .querySelector(options_collection.rangeSliderMax)

        .addEventListener(

          "input",

          (event) => {

            event.preventDefault();

            const target = event.currentTarget;

            if (target.value - minRange.value >= 1) {

              maxPrice.value = target.value;

              maxPriceRange = Number(target.value) * 100;

            } else {

              target.value = Number(minRange.value) + Number(1);

              maxPriceRange = (Number(minRange.value) + Number(1)) * 100;

            }

            const price_format = Shopify.formatMoney(

              maxPriceRange,

              cartStrings.money_format

            );

            document.querySelector(".price-lable .max").innerHTML =

              price_format;

            target

              .closest(".price-range")

              .style.setProperty(

                "--range-to",

                (maxRange.value / Number(target.getAttribute("max"))) * 100 +

                  "%"

              );

          },

          false

        );

      document

        .querySelectorAll(options_collection.rangeSlider)

        .forEach((sliderRange) => {

          sliderRange.addEventListener(

            "change",

            (event) => {

              event.preventDefault();

              const target = event.currentTarget;

              const formData = new FormData(

                document.querySelector(options_collection.collectionFiltersForm)

              );

              const params = new URLSearchParams(formData).toString();

              const nameMin = minPrice.getAttribute("name");

              const nameMax = maxPrice.getAttribute("name");

              var queryString = window.location.search;

              queryString = this.removeParam(nameMin, queryString);

              queryString = this.removeParam(nameMax, queryString);

              var searchParams = queryString.replace("?", "") + "&" + params;

              const url = this.renderUrl(searchParams);

              this.renderSectionFilter(url, searchParams);

            },

            false

          );

        });

    },



    removeParam: function (key, sourceURL) {

      var rtn = sourceURL.split("?")[0],

        param,

        params_arr = [],

        queryString =

          sourceURL.indexOf("?") !== -1 ? sourceURL.split("?")[1] : "";

      if (queryString !== "") {

        params_arr = queryString.split("&");

        for (var i = params_arr.length - 1; i >= 0; i -= 1) {

          param = params_arr[i].split("=")[0];

          if (param === key) {

            params_arr.splice(i, 1);

          }

        }

        if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");

      }

      return rtn;

    },



    renderUrl: function (searchParams) {

      const sectionId = document.querySelector(options_collection.section)

        .dataset.sectionId;

      const url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;

      return url;

    },



    renderSectionFilter: function (url, searchParams) {

      this.toggleLoading(document.body, true);

      fetch(`${url}`)

        .then((response) => {

          if (!response.ok) {

            var error = new Error(response.status);

            throw error;

          }

          return response.text();

        })

        .then((responseText) => {

          if (window.innerWidth <= 1024) {

            const collectionFilterBlocks = new DOMParser()

              .parseFromString(responseText, "text/html")

              .querySelector(options_collection.collectionFilterBlocks);

            document.querySelector(

              options_collection.collectionFilterBlocks

            ).innerHTML = collectionFilterBlocks.innerHTML;

            const productgridcontainer = new DOMParser()

              .parseFromString(responseText, "text/html")

              .querySelector(options_collection.productgridcontainer);

            document.querySelector(

              options_collection.productgridcontainer

            ).innerHTML = productgridcontainer.innerHTML;

            if (

              document

                .querySelector(options_collection.collectionSidebar)

                .classList.contains("open")

            ) {

              document.querySelector(".btn-filter").classList.add("open");

            }

          } else {

            const newSection = new DOMParser()

              .parseFromString(responseText, "text/html")

              .querySelector(options_collection.section);

            document

              .querySelector(options_collection.section)

              .replaceWith(newSection);

          }

          document.documentElement.classList.remove("hside_opened");

          this.toggleLoading(document.body, false);

        })

        .catch((error) => {

          throw error;

        })

        .finally(() => {

          initLazyloadItem();

          eventCollectionShopify.ionRangeSlider();

        });

      this.updateUrl(url, searchParams);

    },



    toggleLoading: function (event, loading) {

      if (event) {

        if (loading) {

          event.classList.add("start", "loading");

        } else {

          event.classList.add("finish");

          setTimeout(function () {

            event.classList.remove("start", "loading", "finish");

          }, 500);

        }

      }

    },



    updateUrl: function (url, searchParams = false) {

      if (searchParams) {

        const urlUpdate = `${window.location.pathname}?${searchParams}`;

        window.history.pushState({ url: urlUpdate }, "", urlUpdate);

      } else {

        window.history.pushState({ url: url }, "", url);

      }

    },

  };

})();

eventCollectionShopify.init();


/* ============================================================
   NM: backdrop do filtro mobile (aditivo, 2026-05-28)
   - desfoca + escurece o fundo enquanto o filtro está aberto
   - bloqueia clique nos produtos atrás (pointer-events)
   - clicar fora (no backdrop) fecha o filtro
   Observa a classe .open do #CollectionSidebar — não altera o fluxo nativo.
   ============================================================ */
(function () {
  "use strict";
  function nmCloseFilterSidebar() {
    var sidebar = document.getElementById("CollectionSidebar");
    if (sidebar) sidebar.classList.remove("open");
    document.documentElement.classList.remove("open-drawer", "open-sidebar");
    var btn = document.querySelector(".btn-filter");
    if (btn) btn.classList.remove("open");
    try {
      if (typeof root !== "undefined" && root && root.style) {
        root.style.removeProperty("padding-right");
      }
    } catch (e) {}
  }
  function nmEnsureBackdrop() {
    var bd = document.querySelector(".nm-filter-backdrop");
    if (!bd) {
      bd = document.createElement("div");
      bd.className = "nm-filter-backdrop";
      bd.addEventListener("click", nmCloseFilterSidebar, false);
      document.body.appendChild(bd);
    }
    return bd;
  }
  function nmSyncBackdrop(sidebar) {
    var bd = nmEnsureBackdrop();
    if (sidebar.classList.contains("open")) bd.classList.add("is-active");
    else bd.classList.remove("is-active");
  }
  function nmInit() {
    var sidebar = document.getElementById("CollectionSidebar");
    if (!sidebar) return false;
    nmSyncBackdrop(sidebar);
    new MutationObserver(function () { nmSyncBackdrop(sidebar); }).observe(
      sidebar,
      { attributes: true, attributeFilter: ["class"] }
    );
    return true;
  }
  if (!nmInit()) {
    var t = setInterval(function () { if (nmInit()) clearInterval(t); }, 300);
  }
})();


/* ============================================================
   NM: paginação numerada via AJAX (aditivo, 2026-06-04)
   - intercepta o clique nos botões numerados (e setas anterior/próxima)
     da paginação numerada (.pagination__item[href]) e roteia pelo MESMO
     eventCollectionShopify.renderSectionFilter usado pelos filtros:
     fetch do section_id + swap (desktop: troca a seção; mobile: innerHTML
     do #productgridcontainer) + overlay de loading. Sem F5.
   - depois do clique, rola suave até o TOPO DA SEÇÃO da coleção
     (#productgridcontainer), nunca o topo literal da página.
   - delegação no document → continua valendo depois de cada swap.
   - respeita ctrl/cmd/shift/botão-do-meio (abrir em nova aba) e
     prefers-reduced-motion.
   ============================================================ */
(function () {
  "use strict";
  if (window.__nmAjaxPaginationInit) return;
  window.__nmAjaxPaginationInit = true;

  var SECTION_SEL = ".sec__collection-main";
  var SCROLL_TARGET = "#productgridcontainer";

  function reduceMotion() {
    return (
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    );
  }

  // altura de um header fixo/sticky no topo, pra não esconder o grid atrás dele
  function stickyOffset() {
    var off = 0;
    var cands = document.querySelectorAll(
      "header, .header, #shopify-section-header, .section-header, [data-header-sticky]"
    );
    cands.forEach(function (el) {
      var cs = getComputedStyle(el);
      if (
        (cs.position === "fixed" || cs.position === "sticky") &&
        el.getBoundingClientRect().top <= 1
      ) {
        off = Math.max(off, el.offsetHeight);
      }
    });
    return off;
  }

  function scrollToCollectionTop() {
    var target =
      document.querySelector(SCROLL_TARGET) ||
      document.querySelector(SECTION_SEL);
    if (!target) return;
    var y =
      target.getBoundingClientRect().top +
      window.pageYOffset -
      stickyOffset() -
      12;
    if (y < 0) y = 0;
    window.scrollTo({ top: y, behavior: reduceMotion() ? "auto" : "smooth" });
  }

  document.addEventListener(
    "click",
    function (ev) {
      // deixa o navegador abrir em nova aba normalmente
      if (ev.defaultPrevented) return;
      if (ev.button !== 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey)
        return;

      var link =
        ev.target &&
        ev.target.closest &&
        ev.target.closest("a.pagination__item[href]");
      if (!link) return;
      // só dentro da seção de coleção
      if (!link.closest(SECTION_SEL)) return;
      // precisa do motor de AJAX do tema; senão deixa navegar normal (F5)
      if (
        typeof eventCollectionShopify === "undefined" ||
        typeof eventCollectionShopify.renderSectionFilter !== "function" ||
        typeof eventCollectionShopify.renderUrl !== "function"
      )
        return;

      var url;
      try {
        url = new URL(link.href, window.location.origin);
      } catch (e) {
        return;
      }
      // só intercepta se for a MESMA coleção (mesmo pathname); senão navega normal
      if (url.pathname !== window.location.pathname) return;

      ev.preventDefault();

      var searchParams = url.search.replace(/^\?/, "");
      var fetchUrl = eventCollectionShopify.renderUrl(searchParams);
      eventCollectionShopify.renderSectionFilter(fetchUrl, searchParams);

      // garante URL limpa na barra (sem section_id, mesmo quando volta pra pág. 1)
      try {
        var clean = url.pathname + url.search;
        window.history.replaceState({ url: clean }, "", clean);
      } catch (e) {}

      // sobe pra seção da coleção (posição estável: o que está acima não muda)
      scrollToCollectionTop();
    },
    false
  );
})();
